/* src/app/features/integracao/scr-controle/scr-controle.component.scss */
.fa-times {
  color: red;
}
.fa-check {
  color: green;
}
.div-progresso {
  margin-top: 10px;
}
.table-responsive {
  margin-top: 10px;
  padding-left: 14px;
  padding-right: 14px;
}
/*# sourceMappingURL=scr-controle.component.css.map */
